module.exports = __webpack_public_path__ + "static/img/275_TO8_2402.e970e32.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/275_TO8_2402.jpg
// module id = e34g
// module chunks = 0